import { render, staticRenderFns } from "./NuevoIngresoEgreso.vue?vue&type=template&id=68b4b402&"
import script from "./NuevoIngresoEgreso.vue?vue&type=script&lang=js&"
export * from "./NuevoIngresoEgreso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports